module.exports = __webpack_public_path__ + "media/images/emblems/Eglisau-blazon-0bade0cfbdeff1732b4e88ba58ede406.svg";